import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  useTheme,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { MenuProps, postGetStyles } from '../muiStyle/muiStyle'

interface TagsComponentProps {
  post: any
  handleInputChange: (e: any) => void
  handleDelete: (value: string) => void
  tags: string[]
}

function TagsComponent({
  post,
  handleInputChange,
  handleDelete,
  tags,
}: TagsComponentProps) {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <>
      <FormControl className="chip-input border-green tags-placeholder">
        <InputLabel shrink={false}>
          {post.tags.length === 0 ? <p>{t('select_tags')}</p> : ''}
        </InputLabel>
        <Select
          multiple
          className="select-border"
          name="tags"
          value={post.tags}
          onChange={handleInputChange}
          renderValue={(selected: any) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {selected.map((value: any) => (
                <Chip
                  key={value}
                  className="chip-color"
                  label={t(`auction_tag.${value}`)}
                  deleteIcon={
                    <i
                      onMouseDown={(e: any) => e.stopPropagation()}
                      className="fa-solid fa-xmark x-mark-icon"
                    />
                  }
                  onDelete={() => handleDelete(value)}
                />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {tags.map((name) => (
            <MenuItem
              key={name}
              value={name}
              style={postGetStyles(name, post.tags, theme)}
            >
              {t(`auction_tag.${name}`)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
}

export default TagsComponent
